// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SecurityAnalyticsSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="SecurityAnalyticsSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M5.273 6.772a12 12 0 0 1 .347-1.76.2.2 0 0 1 .119-.133l4.791-1.825a.25.25 0 0 1 .177 0l4.266 1.678a2.7 2.7 0 0 0-.247-1.131l-3.674-1.453a1.22 1.22 0 0 0-.865 0L5.395 3.973a1.17 1.17 0 0 0-.709.782 13 13 0 0 0-.391 2.058 2.7 2.7 0 0 1 .98-.041z" />
      <path d="M17 7.716a11.2 11.2 0 0 0-.467-3.032 1.15 1.15 0 0 0-.699-.741L15.542 3.83a2.78 2.78 0 0 1 .242 1.84 9.5 9.5 0 0 1-.703 2.07 1.59 1.59 0 0 0-2.206-.299l-1.041-.739a1.806 1.806 0 0 0-1.677-2.468 1.806 1.806 0 0 0-1.663 2.507l-1.79 1.033A2.42 2.42 0 0 0 4.89 6.959a2.43 2.43 0 0 0-2.43 2.428c0 1.34 1.09 2.429 2.43 2.429A2.432 2.432 0 0 0 7.13 8.45l1.833-1.058a1.797 1.797 0 0 0 2.418-.03l.99.703a1.597 1.597 0 0 0 .993 2.184 10 10 0 0 1-.525.52 10.65 10.65 0 0 1-5.432 2.663 3 3 0 0 1-.43.044l-.01-.015a10 10 0 0 1-.958-1.68 2.6 2.6 0 0 1-.95.243c1.458 3.402 4.413 5.322 5.3 5.838a.51.51 0 0 0 .512 0c1.21-.703 6.269-4.018 6.126-10.146zM4.89 11.017a1.63 1.63 0 1 1 .002-3.262 1.63 1.63 0 0 1-.002 3.262m5.266-3.973a1.007 1.007 0 0 1 0-2.011 1.007 1.007 0 0 1 0 2.011m2.873 1.677a.796.796 0 0 1 1.583-.113 10 10 0 0 1-.607.887.797.797 0 0 1-.976-.774" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SecurityAnalyticsSignetIcon = /* @__PURE__ */ Object.assign(
  SecurityAnalyticsSignetIconComponent,
  { displayName: 'SecurityAnalyticsSignetIcon' },
);
